import { Suspense, lazy } from 'react';
import type { PhinAvatarProps } from './phin-avatar/PhinAvatar';

const PhinAvatar = lazy(() =>
  import('./phin-avatar/PhinAvatar').then((module) => ({
    default: module.PhinAvatar,
  })),
);

export function PhinAvatarLazy(props: PhinAvatarProps) {
  return (
    <Suspense fallback={null}>
      <PhinAvatar {...props} />
    </Suspense>
  );
}
